import React from 'react'
import { Code, Brain, ShieldCheck, CloudCog, Users, ArrowRight } from 'lucide-react'

const ServicesSection: React.FC = () => {
  return (
    <section id="services" className="py-20" style={{ backgroundColor: 'var(--card)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: 'var(--text)' }}>Our Services</h2>
          <p className="text-xl max-w-2xl mx-auto" style={{ color: 'var(--text-muted)' }}>
            Comprehensive software solutions designed to illuminate your digital future
          </p>
        </div>
        
        <div className="service-horizontal">
          <div className="service-item">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Code className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text)' }}>Software</h3>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Custom applications</p>
          </div>
          
          <div className="service-arrow">
            <ArrowRight className="w-6 h-6" />
          </div>
          
          <div className="service-item">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Brain className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text)' }}>AI & Data</h3>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Intelligent automation</p>
          </div>
          
          <div className="service-arrow">
            <ArrowRight className="w-6 h-6" />
          </div>
          
          <div className="service-item">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <ShieldCheck className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text)' }}>Security</h3>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Protection by design</p>
          </div>
          
          <div className="service-arrow">
            <ArrowRight className="w-6 h-6" />
          </div>
          
          <div className="service-item">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <CloudCog className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text)' }}>Cloud</h3>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Scalable infrastructure</p>
          </div>
          
          <div className="service-arrow">
            <ArrowRight className="w-6 h-6" />
          </div>
          
          <div className="service-item">
            <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-6 h-6 text-accent" />
            </div>
            <h3 className="font-semibold mb-2" style={{ color: 'var(--text)' }}>Teams</h3>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Developer enablement</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServicesSection